import { useContext } from "react"
import PropTypes from "prop-types"
import Error from "components/error"
import Loading from "components/loading"
import { ERROR, LOADING } from "helpers/data-statuses"
import { useModelBetaFields } from "resources/beta"
import { usePositionSetBetaInstrument } from "connected-components/asset-view/helpers"
import { combineTanStackStatuses } from "helpers/data-statuses"
import FactorsViewBetaComponent from "./component"

export default function FactorsViewBeta({ context, instrumentsWithMetadata, ...props }) {
  const { modelId, endDate } = useContext(context)

  const [modelBetaFields, modelBetaFieldsStatus] = useModelBetaFields(modelId)
  const betaInstrument = usePositionSetBetaInstrument(instrumentsWithMetadata.original, { id: modelId, date: endDate })

  const status = combineTanStackStatuses([modelBetaFieldsStatus])

  if (status === LOADING) {
    return <Loading />
  }
  if (status === ERROR) {
    return <Error />
  }

  return <FactorsViewBetaComponent context={context} betaInstrument={betaInstrument} betaFields={modelBetaFields} instrumentsWithMetadata={instrumentsWithMetadata} {...props} />
}

FactorsViewBeta.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  instrumentsWithMetadata: PropTypes.object.isRequired,
}
